import {API_RESOURCES, createApiCreateAction} from '../../util/api';
import {GET_COMPARE_BODIES_BY_SECTION_ID} from '../actiontypes';

export function getBodiesBySectionId({engagementId, documentId, sectionId, data}) {
	return createApiCreateAction(
		GET_COMPARE_BODIES_BY_SECTION_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FORMS.FORMS]: documentId,
			[API_RESOURCES.FORMS.SECTION]: sectionId,
			[API_RESOURCES.COMPARE]: undefined
		},
		data,
		{
			resolve: true
		}
	);
}
